export enum LocaleUtils {
    EN_US = "en-US",
    EN_IN = "en-IN",
    ES_ES = "es-US",
    FR_FR = "fr-FR",
    PT_BR = "pt-BR"
} 